import {
  FETCH_COMPLETED_TASK_LIST_REQUEST,
  FETCH_COMPLETED_TASK_LIST_SUCCESS,
  FETCH_COMPLETED_TASK_LIST_FALUIRE  
} from './completedTaskListTypes';

const initialState = {
  loading: false,
  completedTaskList: null, 
  error: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COMPLETED_TASK_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
   

    case FETCH_COMPLETED_TASK_LIST_SUCCESS:
      return {
        ...state,
        completedTaskList: action.payload,
        error: '',
        loading: false,
      };

    case FETCH_COMPLETED_TASK_LIST_FALUIRE:
      return {
        ...state,
        loading: false,
        completedTaskList: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
